import { PRIVATE } from 'router/routes';

import { accountTabs } from 'containers/AccountSettings/constants';

export const getSubscriptionsPageUrl = () => `${PRIVATE.ACCOUNT_DEFAULT.path}/${accountTabs.Subscription}`;
